import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const AttachmentSharedActions = {
  downloadAttachment: async (_, blobId) => {
    return axiosRequest.
      get('/active_storage/attachments/' + blobId + '/download_blob', { responseType: 'blob' }).
      then(({ data }) => data).
      catch(handleError)
  },
  getThumbnailForAttachment: async (_, blobId) => {
    return axiosRequest.
      get(`/active_storage/attachments/${blobId}/send_representation`, { responseType: 'blob' }).
      then(({ data }) => data).
      catch(handleError)
  },
  deleteAttachment: async (_, blobId) => {
    return axiosRequest.
      delete('/active_storage/attachments/' + blobId).
      then(({ data }) => data).
      catch(handleError)
  },
}
